<template>
    <div>
        <div 
            class="modal fade" 
            id="partQuotedModal" 
            tabindex="-1" 
            aria-labelledby="partQuotedModalLabel" 
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-dark" id="partQuotedModalLabel">
                            Part Quoted
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex justify-content-center align-items-center my-4 pb-4">
                            <h2>Part quoted with success!</h2>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PartQuotedModal',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
}
</script>